import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgClose = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.33332 15.8333L4.16666 14.6667L8.83332 9.99999L4.16666 5.33332L5.33332 4.16666L9.99999 8.83332L14.6667 4.16666L15.8333 5.33332L11.1667 9.99999L15.8333 14.6667L14.6667 15.8333L9.99999 11.1667L5.33332 15.8333Z",
		fill: "currentColor"
	})
});
export default SvgClose;
